import React, { useEffect, useState } from 'react'
import { Button, Flex, Input, Modal, Pagination, Select } from 'antd'
import './AdminLand.scss'
import { DeleteOutlined, EditOutlined, FilterOutlined, PlusOutlined } from '@ant-design/icons'
import CreateLand from './create-land/CreateLand';
import LandService from '../../service/LandService';
import { useNavigate } from 'react-router-dom';
import EditLand from './edit-land/EditLand';
import Login from './login/Login';

var listCard = [1, 2, 3, 4, 5];

function isTokenExpired(token) {
  console.log("token", token)
  if (!token || token == 'null' || token == null || token == undefined) {
    console.log("return")
    return true;
  }

  const payload = JSON.parse(atob(token.split('.')[1]));
  const exp = payload.exp;

  const now = Date.now() / 1000; // đổi sang giây
  return exp < now;
}

var listPrice = [
  { value: '0', label: 'Tất cả' },
  // { value: '1', label: 'Thỏa thuận' },
  { value: '2', label: 'Dưới 500 triệu' },
  { value: '3', label: '500 - 800 triệu' },
  { value: '4', label: '800 triệu - 1 tỷ' },
  { value: '5', label: '1 - 2 tỷ' },
  { value: '6', label: '2 - 3 tỷ' },
  { value: '7', label: '3 - 5 tỷ' },
  { value: '8', label: '5 - 7 tỷ' },
  { value: '9', label: '7 - 10 tỷ' },
  { value: '10', label: '10 - 20 tỷ' },
  { value: '11', label: '20 - 30 tỷ' },
  { value: '12', label: '30 - 40 tỷ' },
  { value: '13', label: '40 - 60 tỷ' },
  { value: '14', label: 'Trên 60 tỷ' }
]

var listAcreage = [
  { value: '0', label: 'Tất cả' },
  { value: '1', label: 'Dưới 30 m²' },
  { value: '2', label: '30 - 50 m²' },
  { value: '3', label: '50 - 80 m²' },
  { value: '4', label: '80 - 100 m²' },
  { value: '5', label: '100 - 150 m²' },
  { value: '6', label: '150 - 200 m²' },
  { value: '7', label: '200 - 250 m²' },
  { value: '8', label: '250 - 300 m²' },
  { value: '9', label: '300 - 500 m²' },
  { value: '10', label: 'Trên 500 m²' }
]

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth" // cuộn mượt
  });
};

const getPrice = (price) => {
  var res = {
    type: "tr",
    price: price
  }
  if (price >= 1000000) {
    res.type = "tr"
    res.price = price / 1000000
  }

  if (price >= 1000000000) {
    res.type = "tỷ"
    res.price = price / 1000000000
  }

  return `${res.price} ${res.type}`
}

const Image = ({ imageId }) => {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const image = await LandService.getImage(imageId, 'thumbnail');
        setImageSrc(image);
      } catch (error) {
        console.error("Failed to fetch image:", error);
      }
    };
    fetchImage();
  }, []);

  return (
    <img src={imageSrc} alt='land' />
  )
};

const AdminLand = ({ isAdmin }) => {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(false);
  const [token, setToken] = useState('')
  const [isShowFilter, setIsShowFilter] = useState(false);
  const [isShowCreateModal, setIsShowCreateModal] = useState(false)
  const [isShowConfirmModal, setIsShowConfirmModal] = useState(false)
  const [isShowEditModal, setIsShowEditModal] = useState(false)
  const [currentLand, setCurrentLand] = useState(null)
  const [listLand, setListLand] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total_records: 3,
    total_page: 1
  });

  const [filter, setFilter] = useState({
    page: 1,
    size: 6,
    search: "",
    type: null,
    price_from: null,
    price_to: null,
    acreage_from: null,
    acreage_to: null,
    sort: "desc",
    sort_by: "created_time"
  })

  const handleSetToken = (token) => {
    setIsLogin(true)
    setToken(token)
  }

  const getListLand = (filter) => {
    (async () => {
      try {
        // var newFilter = {...filter, ...{page: 1}}
        // setFilter(newFilter)
        const response = await LandService.getList(filter);
        setListLand(response.result);
        setPagination(response.pagination);
      } catch (error) {
        console.log('Failed to fetch menu list: ', error);
      }
    })();
  }

  // const removeLand = () => {
  //   (async () => {
  //     try {
  //       const response = await LandService.getList(filter);
  //       setListLand(response.result);
  //       setPagination(response.pagination);
  //     } catch (error) {
  //       console.log('Failed to fetch menu list: ', error);
  //     }
  //   })();
  // }

  const handleChangePage = (page) => {
    var newFilter = { ...filter, ...{ page: page } }
    setFilter(newFilter)
    getListLand(newFilter)
    scrollToTop()
  }

  const handleChangeSort = (value, option) => {
    var newFilter;
    if (value == "default") {
      newFilter = { ...filter, ...{ sort_by: "created_time", sort: "desc" } }
    }
    else if (value == "price_asc") {
      newFilter = { ...filter, ...{ sort_by: "price", sort: "asc" } }
    }
    else if (value == "price_desc") {
      newFilter = { ...filter, ...{ sort_by: "price", sort: "desc" } }
    }
    else if (value == "acreage_asc") {
      newFilter = { ...filter, ...{ sort_by: "acreage", sort: "asc" } }
    }
    else if (value == "acreage_desc") {
      newFilter = { ...filter, ...{ sort_by: "acreage", sort: "desc" } }
    }
    setFilter(newFilter)
    getListLand(newFilter)
    scrollToTop()
  }

  const handleChangeType = (value) => {
    var newFilter
    if (value == "ALL") {
      newFilter = { ...filter, ...{ type: "" } }
    }
    else {
      newFilter = { ...filter, ...{ type: value } }
    }
    newFilter.page = 1
    setFilter(newFilter)
  }


  const handleChangePrice = (value) => {
    var newFilter
    if (value == "0") {
      newFilter = { ...filter, ...{ price_from: null, price_to: null } }
    }
    else if (value == "2") {
      newFilter = { ...filter, ...{ price_from: 0, price_to: 500 * 1000000 } }
    }
    else if (value == "3") {
      newFilter = { ...filter, ...{ price_from: 500 * 1000000, price_to: 800 * 1000000 } }
    }
    else if (value == "4") {
      newFilter = { ...filter, ...{ price_from: 800 * 1000000, price_to: 1000 * 1000000 } }
    }
    else if (value == "5") {
      newFilter = { ...filter, ...{ price_from: 1000 * 1000000, price_to: 2000 * 1000000 } }
    }
    else if (value == "6") {
      newFilter = { ...filter, ...{ price_from: 2000 * 1000000, price_to: 3000 * 1000000 } }
    }
    else if (value == "7") {
      newFilter = { ...filter, ...{ price_from: 3000 * 1000000, price_to: 5000 * 1000000 } }
    }
    else if (value == "8") {
      newFilter = { ...filter, ...{ price_from: 5000 * 1000000, price_to: 7000 * 1000000 } }
    }
    else if (value == "9") {
      newFilter = { ...filter, ...{ price_from: 7000 * 1000000, price_to: 10000 * 1000000 } }
    }
    else if (value == "10") {
      newFilter = { ...filter, ...{ price_from: 10000 * 1000000, price_to: 20000 * 1000000 } }
    }
    else if (value == "11") {
      newFilter = { ...filter, ...{ price_from: 20000 * 1000000, price_to: 30000 * 1000000 } }
    }
    else if (value == "12") {
      newFilter = { ...filter, ...{ price_from: 30000 * 1000000, price_to: 40000 * 1000000 } }
    }
    else if (value == "13") {
      newFilter = { ...filter, ...{ price_from: 40000 * 1000000, price_to: 60000 * 1000000 } }
    }
    else if (value == "14") {
      newFilter = { ...filter, ...{ price_from: 60000 * 1000000, price_to: 100000 * 1000000 } }
    }
    newFilter.page = 1
    setFilter(newFilter)
  }

  const handleChangeAcreage = (value) => {
    var newFilter
    if (value == "0") {
      newFilter = { ...filter, ...{ acreage_from: null, acreage_to: null } }
    }
    else if (value == "1") {
      newFilter = { ...filter, ...{ acreage_from: 0, acreage_to: 30 } }
    }
    else if (value == "2") {
      newFilter = { ...filter, ...{ acreage_from: 30, acreage_to: 50 } }
    }
    else if (value == "3") {
      newFilter = { ...filter, ...{ acreage_from: 50, acreage_to: 80 } }
    }
    else if (value == "4") {
      newFilter = { ...filter, ...{ acreage_from: 80, acreage_to: 100 } }
    }
    else if (value == "5") {
      newFilter = { ...filter, ...{ acreage_from: 100, acreage_to: 150 } }
    }
    else if (value == "6") {
      newFilter = { ...filter, ...{ acreage_from: 150, acreage_to: 200 } }
    }
    else if (value == "7") {
      newFilter = { ...filter, ...{ acreage_from: 200, acreage_to: 250 } }
    }
    else if (value == "8") {
      newFilter = { ...filter, ...{ acreage_from: 250, acreage_to: 300 } }
    }
    else if (value == "9") {
      newFilter = { ...filter, ...{ acreage_from: 300, acreage_to: 500 } }
    }
    else if (value == "10") {
      newFilter = { ...filter, ...{ acreage_from: 500, acreage_to: 1000000 } }
    }
    newFilter.page = 1
    setFilter(newFilter)
  }

  const handleChangeSearch = (e) => {
    console.log(e.target.value)
    var newFilter = { ...filter, ...{ search: e.target.value } }
    setFilter(newFilter)
  }

  const handleFilter = () => {
    getListLand(filter)
    // scrollToTop()
  }

  const handleButtonDelete = (landData) => {
    setCurrentLand(landData)
    setIsShowConfirmModal(true)
  }

  const createLand = (data, fileList) => {
    (async () => {
      await LandService.create(data, fileList)
      getListLand(filter)
    })();
  }

  const editLand = (data, fileList) => {
    (async () => {
      await LandService.update(currentLand.id, data, fileList)
      getListLand(filter)
    })();
    console.log("edited", data, fileList)
  }

  const handleEditLand = (landData) => {
    setCurrentLand(landData)
    setIsShowEditModal(true)
  }

  const removeLand = () => {
    (async () => {
      setIsShowConfirmModal(false)
      await LandService.remove(currentLand.id)
      getListLand(filter)
    })();
  }

  const goDetail = (landId) => {
    console.log("Go to detail land: ", landId);
    navigate("/detail/" + landId);
    // navigate("/home", { replace: true }); // không lưu history
  };

  useEffect(() => {
    // Fetch land list

    if (isAdmin) {
      var token = localStorage.getItem('token')

      if (isTokenExpired(token)) {
        setIsLogin(false)
      } else {
        setIsLogin(true)
        if (listLand.length === 0) {
          getListLand(filter);
        }
      }
    }
    else {
      if (listLand.length === 0) {
        getListLand(filter);
      }
    }
  }, [isLogin])

  return (
    <>
      {(!isLogin && isAdmin) ? <Login setToken={handleSetToken}></Login> :
        <div className='admin-land-container'>
          <div className='admin-land-search'>
            <div className='list__header'>Mua bán nhà đất Thanh Oai</div>
            <div className='search__input'>
              <Input.Search placeholder="Nhập từ khóa" variant="filled" onChange={handleChangeSearch} onSearch={handleFilter} />
            </div>

            <div className='search__command'>
              <Button className='button-filter' onClick={() => { setIsShowFilter(!isShowFilter) }}><FilterOutlined style={{ color: '#2196F3' }}></FilterOutlined> Lọc</Button>
              {isAdmin && <Button type='primary' onClick={() => { setIsShowCreateModal(true) }}><PlusOutlined></PlusOutlined> Thêm mới</Button>}
            </div>
            {isShowFilter && <div className='search__filter'>
              <div className='search__filter-item'>
                <div className='search__filter-item__title'>Hình thức</div>
                <div className='search__filter-item__select'>
                  <Select
                    defaultValue="Mặc định"
                    options={[
                      { value: 'ALL', label: 'Tất cả' },
                      { value: 'SELL', label: 'Bán' },
                      { value: 'LEASE', label: 'Cho thuê' }
                    ]}
                    style={{ width: '100%' }}
                    onChange={handleChangeType}
                  />
                </div>
              </div>
              <div className='search__filter-item'>
                <div className='search__filter-item__title'>Khoảng giá</div>
                <div className='search__filter-item__select'>
                  <Select
                    defaultValue="Mặc định"
                    options={listPrice}
                    style={{ width: '100%' }}
                    onChange={handleChangePrice}
                  />
                </div>
              </div>
              <div className='search__filter-item'>
                <div className='search__filter-item__title'>Diện tích</div>
                <div className='search__filter-item__select'>
                  <Select
                    defaultValue="Mặc định"
                    options={listAcreage}
                    style={{ width: '100%' }}
                    onChange={handleChangeAcreage}
                  />
                </div>
              </div>
              <div className='search__filter-button'>
                <Button type='primary' onClick={handleFilter}>Xem kết quả</Button>
              </div>
            </div>
            }
            <div className='search__sort'>
              <div className='search__sort-total'>Có {pagination.total_records} bất động sản</div>
              <div className='search__sort-select'>
                <Select
                  defaultValue="Mặc định"
                  options={[
                    { value: 'default', label: 'Mặc định' },
                    { value: 'price_asc', label: 'Giá thấp đến cao' },
                    { value: 'price_desc', label: 'Giá cao đến thấp' },
                    { value: 'acreage_asc', label: 'Diện tích thấp đến cao' },
                    { value: 'acreage_desc', label: 'Diện tích cao đến thấp' },
                  ]}
                  style={{ width: 200 }}
                  onChange={handleChangeSort}
                />
              </div>
            </div>
          </div>
          <div className='admin-land-list'>
            {
              listLand.map((landData, index) => (
                <div className='admin-land-list__card'>
                  <div className='admin-land-list__card__image'>
                    <Image imageId={landData?.list_image_id[0]}></Image>
                  </div>
                  <div className='admin-land-list__card__info'>
                    <div className='admin-land-list__card__info-title' onClick={() => goDetail(landData.id)}>
                      {landData.title}
                    </div>
                    {isAdmin && <div className='admin-land-list__card__title'>
                      <button onClick={() => { handleEditLand(landData) }}><EditOutlined color='#2196F3' style={{ color: '#2196F3' }}></EditOutlined></button>
                      <button onClick={() => { handleButtonDelete(landData) }}><DeleteOutlined color='#F44336' style={{ color: '#F44333' }}></DeleteOutlined></button>
                    </div>}
                  </div>
                  <div className='admin-land-list__card__properties'>
                    <div className='item'>{getPrice(landData?.price)}</div>
                    <div className='item'>{landData?.acreage} m2</div>
                    <div className='item'>{(landData?.price / 1000000 / landData?.acreage).toFixed(2)} tr/m2</div>
                  </div>
                  <div className='admin-land-list__card__description'>
                    {landData?.description}
                  </div>
                </div>
              ))
            }
          </div>
          <div className='admin-land-pagination'>
            <Pagination
              align="center"
              current={pagination.page}
              pageSize={pagination.limit}
              total={pagination.total_records}
              onChange={handleChangePage}
            />
          </div>
          <Modal
            title="Thêm mới bất động sản"
            footer={null}
            open={isShowCreateModal}
            closable={true}
            onCancel={() => setIsShowCreateModal(false)}
          >
            <CreateLand onCreate={createLand} onClose={() => { setIsShowCreateModal(false) }}></CreateLand>
          </Modal>

          <Modal
            title="Chỉnh sửa bất động sản"
            footer={null}
            open={isShowEditModal}
            closable={true}
            onCancel={() => setIsShowEditModal(false)}
          >
            <EditLand data={currentLand} onEdit={editLand} onClose={() => { setIsShowEditModal(false) }}></EditLand>
          </Modal>

          <Modal
            title="Bạn có chắc muốn xóa?"
            open={isShowConfirmModal}
            onCancel={() => setIsShowConfirmModal(false)}
            onOk={removeLand}
          ></Modal>
        </div>}
    </>
  )
}

export default AdminLand